import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { AxiosResponse } from 'axios'
import StudyService from '../Python/APIs/StudyService'
import { useUserContext } from '../../Contexts/UserConfig'

export function useStudyGet(
  path: string | undefined,
  enabled: boolean = true,
  options?: { onSuccess?: (data: any) => void },
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<any, AxiosResponse>(
    ['Study', path],
    () => StudyService.get(whoAmI!, path!),
    {
      enabled: !!whoAmI && enabled,
      onError: (err) => setError(err),
      ...options,
    },
  )
}

export function useStudyUpdate(study_id: string | undefined) {
  const { whoAmI } = useUserContext()
  const queryClient = useQueryClient()
  const { setError } = useMessagePopupContext()
  return useMutation<any, AxiosResponse, any, () => void>(
    (data) => StudyService.updateStudy(whoAmI, study_id!, data),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['PyAPI', '/study'],
        })
      },
      onError: (err) => setError(err),
    },
  )
}

export function useStartSpreadsheet(
  study_id: string,
  UAIs: number[],
  options?: { onSuccess?: (data: any) => void },
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useMutation<any, AxiosResponse, string, () => void>(
    (phase_id) =>
      StudyService.post(
        whoAmI!,
        `/${study_id}/spreadsheet?phase_id=${phase_id}`,
        UAIs,
      ),
    {
      onError: (err) => setError(err),
      ...options,
    },
  )
}

export function useCreateStudy(
  protocol_id: string | null,
  options?: { onSuccess?: (data: any) => void },
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useMutation<any, AxiosResponse>(
    () => StudyService.post(whoAmI!, `?protocol_id=${protocol_id}`),
    {
      onError: (err) => setError(err),
      ...options,
    },
  )
}

export function useUpdateAnimalPhase(
  study_id: string,
  new_phase: string | null,
  selectedQueries: any[],
  setOpen: any,
  selections: number[],
) {
  const { whoAmI } = useUserContext()
  const queryClient = useQueryClient()
  const { setError } = useMessagePopupContext()
  return useMutation<any, AxiosResponse>(
    () =>
      StudyService.updateAnimalPhase(whoAmI, study_id!, new_phase!, selections),
    {
      onSuccess: async () => {
        selectedQueries.forEach((result) => result.refetch())
        await queryClient.invalidateQueries({
          queryKey: ['PyAPI', '/study'],
        })
        setOpen(false)
      },
      onError: (error) => {
        setOpen(false)
        setError(error)
      },
    },
  )
}
